import { CSSTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import MessagesList from './components/MessagesList/MessagesList';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    winnerMessage,
    speed,
    winIds,
  } = useCarousel();
  const {
    bg,
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    bgColor,
    maxLengthMsg,
  } = useGetParams();

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              })center/cover no-repeat, ${bgColor}`
            : `none, ${bgColor}`,
        '--speed': `${speed || 0}ms`,
        '--delay': `${speed / 2 || 0}ms`,
      }}
    >
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="message-wrapper">
          <CSSTransition
            in={showedMessages && Boolean(currentState)}
            timeout={500}
            // classNames="fade-scale"
            unmountOnExit
          >
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              phoneNumberFontSize={phoneNumberFontSize}
              currentState={currentState}
              speed={speed || 0}
              winIds={winIds}
              maxLengthMsg={maxLengthMsg}
            />
          </CSSTransition>
        </div>
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
